<template>
  <section class="footer-location">
    <!-- Title -->
    <div class="footer-location__title">
      {{ $t('footer_5') }}
    </div>

    <!-- Items -->
    <div class="footer-location__items">
      <article class="footer-location__item">
        <!-- Title -->
        <div class="footer-location__item__title">
          {{ $t('footer_6') }}
        </div>

        <!-- Content -->
        <time class="footer-location__item__content">
          {{ getDate('America/New_York') }}
        </time>
      </article>

      <article class="footer-location__item">
        <!-- Title -->
        <div class="footer-location__item__title">
          {{ $t('footer_8') }}
        </div>

        <!-- Content -->
        <time class="footer-location__item__content">
          {{ getDate('Europe/London') }}
        </time>
      </article>

      <article class="footer-location__item">
        <!-- Title -->
        <div class="footer-location__item__title">
          {{ $t('footer_9') }}
        </div>

        <!-- Content -->
        <time class="footer-location__item__content">
          {{ getDate('Europe/London') }}
        </time>
      </article>

      <article class="footer-location__item">
        <!-- Title -->
        <div class="footer-location__item__title">
          {{ $t('footer_11') }}
        </div>

        <!-- Content -->
        <time class="footer-location__item__content">
          {{ getDate('Europe/Copenhagen') }}
        </time>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    getDate(timezone) {
      let options = {
        hour12: false,
        hour: 'numeric',
        minute: 'numeric',
        timeZone: timezone
      };

      return (new Date()).toLocaleString([], options);
    }
  }
};
</script>

<style lang="scss" src="../../assets/components/footer/footer-location-view.scss"></style>



// WEBPACK FOOTER //
// footer-location-view.vue